import compose from 'compose-function';
import { withAntdProvider } from './antd';
import { withNext } from './next';
import { withRouter } from './with-router';
export const withProviders = compose(withAntdProvider, withNext, withRouter);
